import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    communicationGroup: null,
    communicationGroups: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const communicationGroupReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.COMMUNICATION_GROUP_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.COMMUNICATION_GROUP_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.COMMUNICATION_GROUP_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default communicationGroupReducer;
